/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BulkBundleCreate,
  BulkBundleRead,
  GetBulkBundlesParams,
  HTTPValidationError,
  PageBulkBundleRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new bulk bundle.
 * @summary Create Bulk Bundle
 */
export const createBulkBundle = (
  bulkBundleCreate: BulkBundleCreate,
  signal?: AbortSignal,
) => {
  return customInstance<number>({
    url: `/api/bulk_bundle/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkBundleCreate,
    signal,
  });
};

export const getCreateBulkBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBulkBundle>>,
    TError,
    { data: BulkBundleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBulkBundle>>,
  TError,
  { data: BulkBundleCreate },
  TContext
> => {
  const mutationKey = ["createBulkBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBulkBundle>>,
    { data: BulkBundleCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createBulkBundle(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBulkBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBulkBundle>>
>;
export type CreateBulkBundleMutationBody = BulkBundleCreate;
export type CreateBulkBundleMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Bulk Bundle
 */
export const useCreateBulkBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBulkBundle>>,
      TError,
      { data: BulkBundleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBulkBundle>>,
  TError,
  { data: BulkBundleCreate },
  TContext
> => {
  const mutationOptions = getCreateBulkBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many bulk bundles.

Results are paginated.
 * @summary Get Bulk Bundles
 */
export const getBulkBundles = (
  params?: GetBulkBundlesParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageBulkBundleRead>({
    url: `/api/bulk_bundle/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBulkBundlesQueryKey = (params?: GetBulkBundlesParams) => {
  return ["api", "bulk_bundle", ...(params ? [params] : [])] as const;
};

export const getGetBulkBundlesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkBundlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundles>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBulkBundlesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkBundles>>> = ({
    signal,
  }) => getBulkBundles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkBundles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkBundlesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkBundles>>
>;
export type GetBulkBundlesQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkBundles<
  TData = Awaited<ReturnType<typeof getBulkBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetBulkBundlesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkBundles>>,
          TError,
          Awaited<ReturnType<typeof getBulkBundles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkBundles<
  TData = Awaited<ReturnType<typeof getBulkBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkBundlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkBundles>>,
          TError,
          Awaited<ReturnType<typeof getBulkBundles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkBundles<
  TData = Awaited<ReturnType<typeof getBulkBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkBundlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Bundles
 */

export function useGetBulkBundles<
  TData = Awaited<ReturnType<typeof getBulkBundles>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkBundlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkBundlesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a bulk bundle by ID.
 * @summary Get Bulk Bundle
 */
export const getBulkBundle = (bulkBundleId: number, signal?: AbortSignal) => {
  return customInstance<BulkBundleRead>({
    url: `/api/bulk_bundle/${bulkBundleId}`,
    method: "GET",
    signal,
  });
};

export const getGetBulkBundleQueryKey = (bulkBundleId?: number) => {
  return ["api", "bulk_bundle", bulkBundleId] as const;
};

export const getGetBulkBundleQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkBundleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundle>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBulkBundleQueryKey(bulkBundleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkBundle>>> = ({
    signal,
  }) => getBulkBundle(bulkBundleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkBundleId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkBundle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkBundleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkBundle>>
>;
export type GetBulkBundleQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkBundle<
  TData = Awaited<ReturnType<typeof getBulkBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkBundleId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundle>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkBundle>>,
          TError,
          Awaited<ReturnType<typeof getBulkBundle>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkBundle<
  TData = Awaited<ReturnType<typeof getBulkBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkBundleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundle>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkBundle>>,
          TError,
          Awaited<ReturnType<typeof getBulkBundle>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkBundle<
  TData = Awaited<ReturnType<typeof getBulkBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkBundleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundle>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Bundle
 */

export function useGetBulkBundle<
  TData = Awaited<ReturnType<typeof getBulkBundle>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkBundleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkBundle>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkBundleQueryOptions(bulkBundleId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update a bulk bundle by ID.
 * @summary Update Bulk Bundle
 */
export const updateBulkBundle = (
  bulkBundleId: number,
  bulkBundleCreate: BulkBundleCreate,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_bundle/${bulkBundleId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: bulkBundleCreate,
  });
};

export const getUpdateBulkBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkBundle>>,
    TError,
    { bulkBundleId: number; data: BulkBundleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkBundle>>,
  TError,
  { bulkBundleId: number; data: BulkBundleCreate },
  TContext
> => {
  const mutationKey = ["updateBulkBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkBundle>>,
    { bulkBundleId: number; data: BulkBundleCreate }
  > = (props) => {
    const { bulkBundleId, data } = props ?? {};

    return updateBulkBundle(bulkBundleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkBundle>>
>;
export type UpdateBulkBundleMutationBody = BulkBundleCreate;
export type UpdateBulkBundleMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Bundle
 */
export const useUpdateBulkBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkBundle>>,
      TError,
      { bulkBundleId: number; data: BulkBundleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkBundle>>,
  TError,
  { bulkBundleId: number; data: BulkBundleCreate },
  TContext
> => {
  const mutationOptions = getUpdateBulkBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete a bulk bundle by ID.
 * @summary Delete Bulk Bundle
 */
export const deleteBulkBundle = (bulkBundleId: number) => {
  return customInstance<unknown>({
    url: `/api/bulk_bundle/${bulkBundleId}`,
    method: "DELETE",
  });
};

export const getDeleteBulkBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBulkBundle>>,
    TError,
    { bulkBundleId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBulkBundle>>,
  TError,
  { bulkBundleId: number },
  TContext
> => {
  const mutationKey = ["deleteBulkBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBulkBundle>>,
    { bulkBundleId: number }
  > = (props) => {
    const { bulkBundleId } = props ?? {};

    return deleteBulkBundle(bulkBundleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBulkBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBulkBundle>>
>;

export type DeleteBulkBundleMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Bulk Bundle
 */
export const useDeleteBulkBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBulkBundle>>,
      TError,
      { bulkBundleId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBulkBundle>>,
  TError,
  { bulkBundleId: number },
  TContext
> => {
  const mutationOptions = getDeleteBulkBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Restore an archived (soft-deleted) bulk bundle.
 * @summary Restore Bulk Bundle
 */
export const restoreBulkBundle = (
  bulkBundleId: number,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_bundle/restore/${bulkBundleId}`,
    method: "POST",
    signal,
  });
};

export const getRestoreBulkBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreBulkBundle>>,
    TError,
    { bulkBundleId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreBulkBundle>>,
  TError,
  { bulkBundleId: number },
  TContext
> => {
  const mutationKey = ["restoreBulkBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreBulkBundle>>,
    { bulkBundleId: number }
  > = (props) => {
    const { bulkBundleId } = props ?? {};

    return restoreBulkBundle(bulkBundleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreBulkBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreBulkBundle>>
>;

export type RestoreBulkBundleMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Restore Bulk Bundle
 */
export const useRestoreBulkBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreBulkBundle>>,
      TError,
      { bulkBundleId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreBulkBundle>>,
  TError,
  { bulkBundleId: number },
  TContext
> => {
  const mutationOptions = getRestoreBulkBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Copy a bulk bundle to create a patient bundle.

Only available if the entity has the Patient 360 service.
 * @summary Copy Bulk Bundle To Bundle
 */
export const copyBulkBundleToBundle = (
  bulkBundleId: number,
  signal?: AbortSignal,
) => {
  return customInstance<number>({
    url: `/api/bulk_bundle/${bulkBundleId}/copy-to-bundle`,
    method: "POST",
    signal,
  });
};

export const getCopyBulkBundleToBundleMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyBulkBundleToBundle>>,
    TError,
    { bulkBundleId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyBulkBundleToBundle>>,
  TError,
  { bulkBundleId: number },
  TContext
> => {
  const mutationKey = ["copyBulkBundleToBundle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyBulkBundleToBundle>>,
    { bulkBundleId: number }
  > = (props) => {
    const { bulkBundleId } = props ?? {};

    return copyBulkBundleToBundle(bulkBundleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyBulkBundleToBundleMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyBulkBundleToBundle>>
>;

export type CopyBulkBundleToBundleMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Copy Bulk Bundle To Bundle
 */
export const useCopyBulkBundleToBundle = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof copyBulkBundleToBundle>>,
      TError,
      { bulkBundleId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof copyBulkBundleToBundle>>,
  TError,
  { bulkBundleId: number },
  TContext
> => {
  const mutationOptions = getCopyBulkBundleToBundleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
